module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "productAndServices"
  }, [_c('h1', {
    staticClass: "bigTitle"
  }, [_vm._v("产品与服务 "), _c('i', {
    staticClass: "border_bottom"
  })]), _vm._v(" "), _c('p', {
    staticClass: "underInfo"
  }, [_vm._v("以先进的数据生产技术，完善的运营服务体系，丰富的位置服务经验，优质的产品服务质量，为企业提供专业的车辆位置监控服务平台、全面的轨迹云服务体系、炫酷的轨迹大数据可视化平台等产品与服务。")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4ae2d073","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/index/productAndServices.vue
// module id = 136
// module chunks = 1